<template>
  <div class="distribution-areas">
    <!-- Skeleton loader when data is loading -->
    <template v-if="isLoading">
      <v-skeleton-loader v-for="i in 1" :key="i" class="mb-4" type="image" />
    </template>

    <!-- Actual content when data is loaded -->
    <template v-else>
      <div class="contiainer-distubution">
        <div class="contiainer">
          <div class="right-side">
            <div v-if="!isAgents" class="title-wrapper">
              <div class="icon-backgorund">
                <v-icon
                  color="black"
                  icon="mdi-map-marker-radius-outline"
                ></v-icon>
              </div>
              <span class="distribution-title">{{
                truncateText(distributionArea?.linedes)
              }}</span>
            </div>
            <div v-else class="title-wrapper">
              <v-avatar color="#f5f5f5" icon="mdi-account" size="50"></v-avatar>
              <span class="agent-title">
                {{ truncateText(distributionArea?.agentname) }}
              </span>
            </div>
            <div>
              <v-progress-circular
                class="pressnet-wrapper"
                color="#801512"
                :size="144"
                :width="12"
                :model-value="orderForTommrowPercentage"
                ><div>
                  <div>
                    <span class="sales-number">
                      {{ distributionArea?.agentSales }}
                    </span>
                    <span class="sales-separator">/</span>
                    <span class="sales-goal">
                      {{ distributionArea?.agentgoalSales }}</span
                    >
                  </div>
                </div>
              </v-progress-circular>
              <div class="sales-amount">
                {{ formatPrice(distributionArea?.agentSalesNls) }} ₪
              </div>
              <div>
                <v-icon
                  :color="'#801512'"
                  icon="mdi-clipboard-text-clock"
                ></v-icon>
                <span class="orders-label">הזמנות למחר</span>
              </div>
            </div>
          </div>
          <div class="left-side">
            <div
              @click="gotoOrdersPage(distributionArea)"
              class="info-wrapper blue hover"
              :class="[
                distributionArea?.openOrdersCount > 0 ? 'cursor-pointer' : '',
              ]"
              :style="{
                'pointer-events':
                  distributionArea?.openOrdersCount > 0 ? '' : 'none',
              }"
            >
              <div class="info-number">{{ distributionArea?.openOrdersCount }}</div>

              <div class="d-flex ga-2 info-label">
                <v-icon :color="'#801512'" icon="mdi-text-box"></v-icon>
                <span class="info-text">הזמנות פתוחות </span>
              </div>
            </div>
            <div
              @click="gotoCustomersPage(distributionArea)"
              class="info-wrapper green hover"
              :class="[
                distributionArea?.activeCustomersCount > 0
                  ? 'cursor-pointer'
                  : '',
              ]"
              :style="{
                'pointer-events':
                  distributionArea?.activeCustomersCount > 0 ? '' : 'none',
              }"
            >
              <div class="info-number">
                {{ distributionArea?.activeCustomersCount }}
              </div>
              <div class="d-flex ga-2 info-label">
                <v-icon
                  :color="'#801512'"
                  icon="mdi-account-group-outline"
                ></v-icon
                ><span class="info-text">לקוחות פעילים</span>
              </div>
            </div>
          </div>
        </div>
        <div v-if="isAgents" class="agents">
          <div class="title-agents">
            <div class="title-agents-right">
              <v-icon icon="mdi-chart-bar"></v-icon>
              <span class="monthly-goal-label">יעד חודשי</span>
              <div class="monthly-goal-amount">
                {{ distributionArea?.monthlyGoal?.toLocaleString() }} ₪
              </div>
            </div>
            <div
              v-if="getUserRole?.agentapp"
              @click="isAgentModal = true"
              class="title-agents-left"
            >
              <v-icon :size="15" icon="mdi-pencil"></v-icon>
              <span class="edit">עריכה</span>
            </div>
          </div>
          <div>
            <v-progress-linear
              class="progress-linear"
              v-model="goalPerecntage"
              color="#801d18"
              height="20"
            >
              <strong class="perecntage-label"
                >{{
                  formatPrice(goalPerecntage > 100 ? 100 : goalPerecntage)
                }}%</strong
              >
            </v-progress-linear>
            <div class="monthly-sales-info">
              <span class="monthly-sales-label"> הוזמן החודש </span>
              <span class="monthly-sales-currency">₪</span>
              <span class="monthly-sales-amount">
                {{ formatPrice(distributionArea?.agnetSalesInNls) }}
              </span>
            </div>
          </div>
        </div>
      </div>
      <AgentMonthlyGoalModal
        v-if="isAgentModal"
        :openModal="isAgentModal"
        :monthlyGoal="distributionArea?.monthlyGoal"
        :agentName="distributionArea?.agentname"
        @closeModal="isAgentModal = false"
        @updateNewAgentMonthlyGoal="updateNewAgentMonthlyGoal"
      />
    </template>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import AgentMonthlyGoalModal from "../UI/modals/AgentMonthlyGoalModal.vue";
import { truncateText, formatPrice } from "@/utilities.js";

export default {
  components: {
    AgentMonthlyGoalModal,
  },
  data() {
    return {
      isAgentModal: false,
    };
  },
  computed: {
    ...mapGetters({
      getUserRole: "AuthModule/getUserRole",
    }),
    orderForTommrowPercentage() {
      return (
        (this.distributionArea?.agentSales /
          this.distributionArea?.agentgoalSales) *
        100
      );
    },
    goalPerecntage() {
      const value1 = Math.ceil(this.distributionArea?.monthlyGoal);
      const value2 = Math.ceil(this.distributionArea?.agnetSalesInNls);
      const perectage = (value2 / value1) * 100;
      return isNaN(perectage) ? 0 : perectage;
    },
  },
  methods: {
    formatPrice(price) {
      return formatPrice(price);
    },
    async updateNewAgentMonthlyGoal(newMonthlyGoal) {
      try {
        const response = await this.$store.dispatch(
          "ControlPanel/updateNewAgentMonthlyGoal",
          {
            newMonthlyGoal: newMonthlyGoal,
            agent: this.distributionArea.agent,
          }
        );
        if (response) this.isAgentModal = false;
      } catch (error) {
        console.log(error);
      }
    },
    gotoOrdersPage(distributionArea) {
      let query = {
        mainStatus: 2,
      };
      if (this.isAgents) query.agentId = distributionArea.agent;
      else query.distLine = distributionArea.linekey;
      this.$router.push({ path: "/orders/allorders", query });
    },
    gotoCustomersPage(distributionArea) {
      let query = {
        status: 1,
      };
      if (this.isAgents) query.agentId = distributionArea.agent;
      else query.distLine = distributionArea.linekey;
      this.$router.push({ path: "/customers/allcustomers", query });
    },
    truncateText(text) {
      return truncateText(text, 10);
    },
  },
  props: {
    isLoading: {
      type: Boolean,
      default: false,
    },
    tableLineBackground: {
      type: String,
      default: "transparent",
    },
    isAgents: {
      type: Boolean,
      defult: false,
    },
    distributionArea: {
      type: Object,
      rqeuired: true,
    },
  },
};
</script>
<style lang="scss">
.distribution-areas {
  .grid {
    grid-template-columns: repeat(auto-fill, minmax(340px, 1fr));
  }
  .v-progress-linear__background {
    background-color: #8d8d8d !important;
  }
  .v-progress-linear__determinate {
    border-radius: 50px;
  }
  .v-progress-circular__underlay {
    color: #656565 !important;
  }
  .v-skeleton-loader__image {
    border-radius: 20px;
    width: 320px;
    height: 320px;
  }

  .v-progress-linear__background,
  .v-progress-linear__buffer {
    opacity: unset;
  }
}
</style>
<style scoped lang="scss">
//vuetify
.v-progress-linear__content {
  strong {
    color: #ffffff !important;
    font-size: $smallTextSize;
    font-weight: 400;
  }
}
.contiainer-distubution {
  border: 1px solid $borderColor;
  background-color: v-bind(tableLineBackground);
  border-radius: 20px;
  max-width: 440px;
  padding: 20px;
  .contiainer {
    margin-bottom: 20px;
    display: flex;
    flex-direction: row;
  }

  .right-side {
    padding-left: 30px;
    border-left: 2px dashed $borderColor;
  }

  @include media(tablet) {
    // Tablet styles
    max-width: 350px;
    padding: 15px;
    
    .contiainer {
      margin-bottom: 15px;
    }
    
    .right-side {
      padding-left: 20px;
    }
    
    .left-side {
      padding-right: 20px;
      gap: 15px;
    }
    
    // Reduce font sizes for tablet
    .info-number {
      font-size: 35px !important;
    }
    
    .sales-separator {
      font-size: 20px !important;
    }
    
    .orders-label,
    .info-text,
    .monthly-goal-label {
      font-size: 16px !important;
    }
    
    .distribution-title,
    .sales-amount,
    .monthly-goal-amount {
      font-size: 16px !important;
    }
    
    .agent-title {
      font-size: 14px !important;
    }
    
    .monthly-sales-amount {
      font-size: 20px !important;
    }
    
    .sales-number {
      font-size: 35px !important;
    }
    
    .sales-goal {
      font-size: 20px !important;
    }
    
    .v-progress-circular {
      width: 120px !important;
      height: 120px !important;
    }
    
    .title-wrapper {
      margin-bottom: 20px;
      
      .icon-backgorund {
        padding: 12px;
      }
      
      .v-avatar {
        width: 40px !important;
        height: 40px !important;
      }
    }
    
    .info-wrapper {
      padding: 15px;
    }
  }

  @media (max-width: 768px) {
    .right-side {
      padding-bottom: 10px;
    }

    .info-wrapper {
      padding: 6px !important;
    }

    .left-side,
    .right-side {
      width: 100% !important;
      padding: 0px !important;
    }

    .right-side {
      padding-bottom: 10px !important;
      padding-left: 10px !important;
    }

    .left-side {
      padding-right: 7px !important;
    }
  }

  .left-side {
    display: flex;
    padding-right: 30px;
    gap: 20px;
    flex-direction: column;
  }
}
.title-wrapper {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 25px;
  .icon-backgorund {
    background: $primaryBackgroundColor;
    padding: 15px;
    border-radius: 50%;
  }
}
.pressnet-wrapper {
  margin-bottom: 8px;
}
.info-wrapper {
  background: $grayBackgroundColor;
  padding: 20px;
  text-align: start;
  border-radius: 20px;
  &.hover:hover {
    color: white;
    span,
    i {
      color: white !important;
      caret-color: white !important;
    }
  }
  &.blue:hover {
    background: $ordersMainColor;
  }
  &.green:hover {
    background: $customerMainColor;
  }
}
.title-agents {
  display: flex;
  justify-content: space-between;

  .title-agents-right {
    display: flex;
    gap: 5px;
  }
  .title-agents-left {
    display: flex;
    align-items: center;
    gap: 5px;
    cursor: pointer;
    .edit {
      text-decoration: underline;
    }
  }
}
.agent-sales-nls-label {
  color: $primaryColor;
}
.progress-linear {
  background: $grayBackgroundColor;
  margin-top: 10px;
  border-radius: 50px;
}

// New styles replacing class helpers
.distribution-title {
  font-size: 23px;
  font-weight: bold;
  text-align: start;
  color: black;
}

.agent-title {
  font-size: 18px;
  font-weight: bold;
  text-align: start;
  color: black;
}

.sales-number {
  font-size: 45px;
  color: black;
}

.sales-separator {
  font-size: 25px;
  color: black;
}

.sales-goal {
  font-size: 25px;
  color: black;
}

.sales-amount {
  font-size: 18px;
  font-weight: 600;
  margin-top: -10px;
  color: $primaryColor;
}

.orders-label {
  font-size: 18px;
  color: #000000;
}

.info-number {
  font-size: 45px;
}

.info-label {
  margin-top: -10px;
}

.info-text {
  font-size: 18px;
  color: #000000;
}

.monthly-goal-label {
  font-size: 18px;
  color: #000000;
}

.monthly-goal-amount {
  font-size: 18px;
  font-weight: 600;
}

.monthly-sales-info {
  text-align: start;
}

.monthly-sales-label {
  font-weight: 600;
}

.monthly-sales-currency {
  font-weight: 600;
}

.monthly-sales-amount {
  font-weight: 600;
  font-size: 24px;
}
</style>
